import React, { useEffect } from "react";
import {
  useAppEventsSelector,
  useAppPerformancesSelector,
  useAppRidersSelector,
  useAppRodeoEventsSelector,
} from "src/_common/hooks/selectors/eventSelector";

interface GetInfoByIdProps {
  type: string; // RE for rodeo-event, P for performance, E for event, R for rider
  id: string;
  setItemDetails: any;
}

const GetInfoById = ({ type, id, setItemDetails }: GetInfoByIdProps) => {
  const rodeoEvents = useAppRodeoEventsSelector()?.list;
  const performances = useAppPerformancesSelector()?.list;
  const events = useAppEventsSelector()?.list;
  const riders = useAppRidersSelector()?.list;

  useEffect(() => {
    let list = [];
    if (id && type) {
      if (type === "RE") {
        list = rodeoEvents;
      } else if (type === "P") {
        list = performances;
      } else if (type === "E") {
        list = events;
      } else if (type === "R") {
        list = riders;
      }
      setItemDetails(list?.find((item: any) => item.id == id) || null);
    }
  }, [type, id]);

  return <></>;
};

export default GetInfoById;
